import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TourDashboardSummaryDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardSummaryDto.ts';
import { TourFinanceDashboardDto } from '@/features/dashboard/tours/types/dashboard/dto/TourFinanceDashboardDto.ts';
import { TourDashboardOptionsDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardOptionsDto.ts';
import { TourDashboardSalesDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardSalesDto.ts';

/**
 * Karty ekranu wyjazdu — obłożenie, saldo, budżet, opcje, sprzedaż. Wszystko
 * z modułu statystyk backendu, po jednym wywołaniu na zakładkę: wpłaty i budżet
 * czyta się razem, więc jadą jedną odpowiedzią.
 *
 * Panele „Wymaga uwagi” Podsumowania i Opcji nie przechodzą tędy — to inny
 * moduł backendu z własnym czasem przeliczenia, patrz `tourAttentionApi.ts`.
 */
const statsPath = (tourId: string) => `statistics/tours/${tourId}`;

const tourDashboardApi = {
  getSummary: async (tourId: string): Promise<TourDashboardSummaryDto> => {
    return await fetchPrivateApi<TourDashboardSummaryDto>(
      'GET',
      `${statsPath(tourId)}/summary`,
    );
  },

  getFinance: async (tourId: string): Promise<TourFinanceDashboardDto> => {
    return await fetchPrivateApi<TourFinanceDashboardDto>(
      'GET',
      `${statsPath(tourId)}/finance`,
    );
  },

  getOptions: async (tourId: string): Promise<TourDashboardOptionsDto> => {
    return await fetchPrivateApi<TourDashboardOptionsDto>(
      'GET',
      `${statsPath(tourId)}/options`,
    );
  },

  getSales: async (tourId: string): Promise<TourDashboardSalesDto> => {
    return await fetchPrivateApi<TourDashboardSalesDto>(
      'GET',
      `${statsPath(tourId)}/sales`,
    );
  },
};

export default tourDashboardApi;
